import React, { memo } from "react";
import PropTypes from "prop-types";
import CustomSelect from '../select/index.jsx';

const Dropdown = ({ options, onChange, defaultValue, ...rest }) => {
  return (
    <CustomSelect
      options={options}
      onChange={onChange}
      value={defaultValue}
      {...rest}
    />
  );
};

Dropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.any,
};

Dropdown.defaultProps = {
  defaultValue: null,
};

export default memo ( Dropdown );



